/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getCargoReleaseList, getMilestoneConfigCR } from '../../store/cargoRelease/actions';
import { getNameClient } from './../../helpers/nameClient';
//redux
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import usePageTitle from '../../common/hooks/usePageTitle';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import Filters from '../../components/Common/Filters/filters';
import { getDynamicAttrUpdated, getDynamicFilterCF, transformCFColumnsData } from '../../helpers/tools_helper';
import { cancelFetchCR } from '../../store/cargoRelease/saga';
import IForm from '../salesOrderList/iForm';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';
import IButtonComponent from '../../components/Common/iComponents/iButton/IButton';
import { Link, useLocation } from 'react-router-dom';

const CargoRelease = (props: any) => {

    const location = useLocation<{ parametro?: boolean }>();  
    const parametro = location.state?.parametro;

    
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isFirstRun, setIsFirstRun] = useState(true);
    const [title, setTitle] = useState('');
    const groupName = 'cargoReleaseViewList';
    const PageTitleCR = usePageTitle(props.location.pathname);
    const { data, isLoading, milestoneConfig, CountItems } = useSelector((state: any) => state.cargoRelease);
    const currentDate = new Date();

    const [form, setForm] = useState({
        from: moment(currentDate).format('YYYY-MM-DD'),
        to: moment(currentDate).format('YYYY-MM-DD'),
        order: "{'createdAt' : 'DESC'}",
        Number: '',
        dynamicFilter: '',
        dynamicFilterCF: '',
    });
    const [pagination, setPagination] = useState<any>({
        sizePerPage: 50,
        page: 1,
    });

    const [tableConfig, setTableConfig] = useState([]);
    const [cargoReleaseList, setcargoReleaseList] = useState<any[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getMilestoneConfigCR());
    }, []);

    useEffect(() => {
        if (isFirstRun) {
          const filters = JSON.parse(localStorage.getItem("filterOperation") || "{}");
          if (filters[groupName]) {
            handleActionOnSearch(filters[groupName]);
          }
          setIsFirstRun(false);
        } else {
          dispatch(getCargoReleaseList({ form, pagination }));
        }
      }, [dispatch, form, pagination, isFirstRun]);

    useEffect(() => {
        setcargoReleaseList(data);
    }, [data]);

    useEffect(() => {
        let listFinal: any[] = [];
        listFinal = transformCFColumnsData(data);
        setcargoReleaseList(listFinal);
    }, [data]);

    useEffect(() => {}, [data]);

    useEffect(() => {
        const dataSorted = milestoneConfig.sort(function (a: any, b: any) {
            const x = a.order;
            const y = b.order;
            //compare the word which is comes first
            if (x > y) {
                return 1;
            }
            if (x < y) {
                return -1;
            }
            return 0;
        });
        dataSorted.forEach((milestone: any) => {
            milestone.hidden = !milestone.visibleInTable;
            //milestone.filter = textFilter()
        });
        setTableConfig(dataSorted);
        //setIsPageLoading(false);
    }, [milestoneConfig]);


    const handleActionOnSearch = (data: any) => {
        const filterString = getDynamicAttrUpdated(data);
        const getFilterCF = getDynamicFilterCF(data);
        const newPagination = { ...pagination, page: 1 };
        setPagination(newPagination);
        const newForm = {
            ...data,
            order: form.order,
            dynamicFilter: filterString,
            dynamicFilterCF: getFilterCF,
        };
        setForm(newForm);
    };

    const processList = (list: any[], selectedRow: any) => {
        const t: any[] = [];
        for (const item in selectedRow) {
            list.map(function (data: { dataField: string }) {
                if (data.dataField === item)
                    t.push({
                        ...data,
                        value: selectedRow[item],
                    });
                return data;
            });
        }

        return t;
    };

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
        const visibleInModalFooter = milestoneConfig.filter((x: { visibleInModalFooter: boolean }) => x.visibleInModalFooter === true);
        let titleArr = processList(visibleInModalFooter, row);
        titleArr = titleArr.map((x) => {
            return x.value;
        });
        setTitle(titleArr.join(' - '));
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
        setForm({ ...form, order: `{'${sortField ?? 'createdAt'}' : '${sortOrder.toUpperCase()}'}` });
    };
    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <PageTitle>
                    <title>
                        {PageTitleCR.replace(/-/g, ' ')} | {getNameClient()}
                    </title>
                </PageTitle>
                <Container fluid>
                    <Row>
                        <Filters onSearchClicked={handleActionOnSearch} filterItems={milestoneConfig} groupName={groupName} />
                    </Row>
                    <Row>
                        <Link to={'/cargoRelease'}>
                            <IButtonComponent
                                className="btn-search"
                                label={'Creation CR'}
                                btnIcon="bx bx-add-to-queue"
                            ></IButtonComponent>
                        </Link>
                    </Row>
                    <Row>
                        <div className="container">
                            <Iloading avoidSwalInFirstRender={parametro} cancelFetch={cancelFetchCR} loading={isLoading}/>
                        </div>
                        {cargoReleaseList.length > 0 ? (
                            milestoneConfig.length === 0 ? (
                                <>
                                    <div>No config operations for this table</div>
                                </>
                            ) : (
                                <>
                                    <ITable
                                        remote={true}
                                        CountItems={CountItems}
                                        handlerPaginationState={handlePaginationChange}
                                        data={cargoReleaseList}
                                        fields={milestoneConfig}
                                        tableColumns={milestoneConfig}
                                        headerColorT={'bg-primary text-white'}
                                        groupName={groupName}
                                        handlePopUpState={onPopUpState}
                                        actionOnRowClick={handleActionOnRowClick}
                                        handleTableSort={handleTableSort}
                                    />
                                </>
                            )
                        ) : (
                            <div style={{ height: 180 }} />
                        )}
                    </Row>
                </Container>
            </div>

            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={title}
                modaleTitleUpdate={'Cargo Releases'}
                icon="shopping-bag"
                colorHeaderPop={'#101340'}
                width="93%"
                height="93%"
            >
                <IForm groupName={groupName} selectedRow={selectedRow} milestoneConfig={tableConfig} columsPop={5} />
            </IPopUp>
        </React.Fragment>
    );
};

export default CargoRelease;
